import styled from '@emotion/styled';
import CommentButton from 'components/button/comment_button';
import DeleteButton from 'components/button/delete_button';
import React from 'react';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  width: 100%;
  margin-top: ${props => props.marginTop || '10px'};
`;

const IconWrapper = styled.div`
  margin-right: 3px;
  .fa-times {
    margin-top: 1px;
  }
  .fa-refresh {
    margin-top: 2px;
    font-size: 10px;
  }
`;

const ReviewCardActions = ({
  onManage,
  onReset,
  onDelete,
  marginTop,
}) => {
  return (
    <Wrapper
      marginTop={marginTop}
    >
      {
        onManage &&
        <CommentButton
          height='25px'
          fontWeight='bold'
          fontSize='12px'
          onClick={onManage}
        >
          <IconWrapper>
            <i className='fa fa-pencil' />
          </IconWrapper>
          Manage Review
        </CommentButton>
      }
      {
        onReset &&
        <DeleteButton
          allowDeletion
          onConfirm={onReset}
          message='Reset this Review?'
        >
          <CommentButton
            height='25px'
            fontWeight='bold'
            fontSize='12px'
          >
            <IconWrapper>
              <i className='fa fa-refresh' />
            </IconWrapper>
            Reset Review
          </CommentButton>
        </DeleteButton>
      }
      {
        onDelete &&
        <DeleteButton
          allowDeletion
          onConfirm={onDelete}
          message='Delete this Review?'
        >
          <CommentButton
            height='25px'
            fontWeight='bold'
            fontSize='12px'
          >
            <IconWrapper>
              <i className='fa fa-times' />
            </IconWrapper>
            Delete Review
          </CommentButton>
        </DeleteButton>
      }
    </Wrapper>
  );
};

export default ReviewCardActions;
